import { useState } from 'react';

export const DropDown = ({ titleIcon, dropdownArray, title, triggerClass, listClass }) => {
  const [display, setDisplay] = useState(false)
  return (
      <div className='relative'>
        <div className={triggerClass} onClick={() => setDisplay(prevState => !prevState)}>
          <div>{title}</div>
          <div>{titleIcon}</div>
        </div>
        {
          display && (  
            <>
              <div onClick={() => setDisplay(false)} className="w-screen h-screen fixed inset-0 z-[9999] bg-black opacity-20"></div>
            <div className="top-[2.5rem] absolute right-0 buttom-[-4rem] border bg-[#FFFFFF] rounded-lg dropdownNew z-[10000]">
              {
                dropdownArray.map((item, index) => {
                  const { icon, title, func, color } = item;
                  return (
                    <div key={index} className={`${listClass} z-[11000] bg-[#FFFFFF]`} onClick={() => {
                      setDisplay(false);
                      func();
                    }}>
                      {icon}
                      <div className={`${color ? color : ""} text-nowrap hover:text-[#FFFFFF]`}>{title}</div>
                    </div>
                  )
                })
              }
            </div>
            </>
          )
        }
      </div>
  )
}


export default DropDown;
